var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"commonEmptyBox"},[_c('van-empty',{attrs:{"image":_vm.errorUrl,"description":_vm.description || _vm.$t('empty.commonEmpty'),"image-size":_vm.imageSize}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }